import { db } from '../lib/firebase';
import { collection, addDoc, getDocs } from 'firebase/firestore';

export const addSampleSuppliers = async () => {
  try {
    console.log('Adding sample suppliers...');
    
    const sampleSuppliers = [
      {
        name: 'ABC Upholstery Services',
        email: 'contact@abcupholstery.com.au',
        phone: '+61 2 9876 5432',
        category: 'upholstery',
        specialties: ['Custom Furniture', 'Fabric Selection', 'Leather Work'],
        address: '123 Industrial Drive, Alexandria NSW 2015',
        website: 'https://www.abcupholstery.com.au',
        notes: 'Premium upholstery specialists with 15+ years experience',
        rating: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Premium Fabric Co',
        email: 'orders@premiumfabric.com.au',
        phone: '+61 3 8765 4321',
        category: 'fabric',
        specialties: ['Premium Fabrics', 'Eco-Friendly Materials', 'Bulk Orders'],
        address: '456 Textile Street, Richmond VIC 3121',
        website: 'https://www.premiumfabric.com.au',
        notes: 'Wide selection of premium and sustainable fabrics',
        rating: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Swift Delivery Services',
        email: 'bookings@swiftdelivery.com.au',
        phone: '+61 7 5432 1098',
        category: 'delivery',
        specialties: ['Rush Delivery', 'Installation', 'Bulk Orders'],
        address: '789 Logistics Way, Brisbane QLD 4000',
        website: 'https://www.swiftdelivery.com.au',
        notes: 'Reliable delivery and installation services across Australia',
        rating: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Elite Furniture Makers',
        email: 'info@elitefurniture.com.au',
        phone: '+61 8 3210 9876',
        category: 'furniture',
        specialties: ['Custom Furniture', 'Modern Design', 'Commercial Projects'],
        address: '321 Craft Avenue, Adelaide SA 5000',
        website: 'https://www.elitefurniture.com.au',
        notes: 'Bespoke furniture manufacturing for high-end projects',
        rating: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Design Installation Pros',
        email: 'team@designinstall.com.au',
        phone: '+61 4 1234 5678',
        category: 'installation',
        specialties: ['Installation', 'Consultation', 'Rush Delivery'],
        address: '654 Service Road, Perth WA 6000',
        website: 'https://www.designinstall.com.au',
        notes: 'Professional installation team for all interior projects',
        rating: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ];

    for (const supplier of sampleSuppliers) {
      await addDoc(collection(db, 'suppliers'), supplier);
      console.log(`Added supplier: ${supplier.name}`);
    }

    console.log('✅ Sample suppliers added successfully!');
    return sampleSuppliers.length;

  } catch (error) {
    console.error('Error adding sample suppliers:', error);
    throw error;
  }
};

export const addSampleCustomers = async () => {
  try {
    console.log('Adding sample customers...');
    
    const sampleCustomers = [
      {
        name: 'Sarah Johnson',
        email: 'sarah.johnson@email.com',
        phone: '+61 400 123 456',
        company: '',
        address: '123 Heritage Street, Paddington NSW 2021',
        notes: 'Prefers modern minimalist designs with neutral color palette',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Michael Chen',
        email: 'michael.chen@email.com',
        phone: '+61 400 234 567',
        company: 'Chen & Associates Law',
        address: '456 Business Plaza, Melbourne VIC 3000',
        notes: 'Corporate office renovation project, budget flexible',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        name: 'Emma Thompson',
        email: 'emma.thompson@email.com',
        phone: '+61 400 345 678',
        company: '',
        address: '789 Coastal Drive, Gold Coast QLD 4217',
        notes: 'Coastal theme interior, loves blues and whites',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ];

    for (const customer of sampleCustomers) {
      await addDoc(collection(db, 'customers'), customer);
      console.log(`Added customer: ${customer.name}`);
    }

    console.log('✅ Sample customers added successfully!');
    return sampleCustomers.length;

  } catch (error) {
    console.error('Error adding sample customers:', error);
    throw error;
  }
};

export const checkExistingData = async () => {
  try {
    const suppliersSnapshot = await getDocs(collection(db, 'suppliers'));
    const customersSnapshot = await getDocs(collection(db, 'customers'));
    
    return {
      suppliers: suppliersSnapshot.docs.length,
      customers: customersSnapshot.docs.length
    };
  } catch (error) {
    console.error('Error checking existing data:', error);
    return { suppliers: 0, customers: 0 };
  }
};